var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m459.37,151.72c.33,4.55.33,9.1.33,13.65,0,138.72-105.58,298.56-298.56,298.56-59.45,0-114.68-17.22-161.14-47.11,8.45.97,16.57,1.3,25.34,1.3,49.06,0,94.21-16.57,130.27-44.83-46.13-.98-84.79-31.19-98.11-72.77,6.5.97,13,1.62,19.82,1.62,9.42,0,18.84-1.3,27.61-3.57-48.08-9.75-84.14-51.98-84.14-102.99v-1.3c13.97,7.8,30.21,12.67,47.43,13.32-28.26-18.84-46.78-51.01-46.78-87.39,0-19.49,5.2-37.36,14.29-52.95,51.65,63.68,129.3,105.26,216.37,109.81-1.62-7.8-2.6-15.92-2.6-24.04,0-57.83,46.78-104.93,104.93-104.93,30.21,0,57.5,12.67,76.67,33.14,23.71-4.55,46.46-13.32,66.6-25.34-7.8,24.37-24.37,44.83-46.13,57.83,21.12-2.27,41.58-8.12,60.43-16.24-14.29,20.79-32.16,39.31-52.63,54.25h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.99659357e3816709f30c4964f47bdf04.svg";
export { ForwardRef as ReactComponent };